import { HttpClient } from '@angular/common/http';
import { ICapture } from './../interfaces/capture';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment";


@Injectable({
  providedIn: 'root'
})
export class CaptureService {

  private switch = false;
  private capture: ICapture;
  token = { api_token: `${localStorage.getItem('token')}` };
  private data1 = [];

  constructor(
    private http: HttpClient
  ) { }

  get url() {
    return `${environment.api}/${this.endpoint()}`;
  }

  endpoint(): string {
    return "capture";
  }


  get listCapture(): ICapture[] {
    return this.listCapture;
  }

  addCapture(capture: ICapture) {
    this.capture = capture
    return this.capture;
    //this.listCapture.push(capture);
  }

  // getData(capture: ICapture[]){
  //   this.capture = {
  //   'id_planta': '1235',
  //   'cedula':'425655',
  //   }
  //   return  this.capture;
  // }


  getCapture(): any {
    return this.capture;
  }

  addRegister(capture: ICapture) {
    let url = this.url + '/capturehor?';

    const data = {
      "id_planta": capture.id_planta,
      "cedula": capture.cedula,
      "orden_ceco": capture.orden_ceco,
      "linea": capture.linea,
      "filtro_linea": capture.filtro_linea,
      "latitude": capture.latitude,
      "longitude": capture.longitude,
      "showSalida": capture.showSalida,
      'entrega':capture.entrega,
      'observaciones':capture.observaciones,
      "api_token": this.token.api_token,


    }
    return this.http.post(url, data);

    //  return this.capture;
    //this.listCapture.push(capture);
  }

  addCode(capture: ICapture) {
    let url = this.url + '/capturehor?';

    const data = {
      "id_planta": capture.id_planta,
      "cedula": capture.cedula,
      "orden_ceco": capture.orden_ceco,
      "linea": capture.linea,
      "filtro_linea": capture.filtro_linea,
      "latitude": capture.latitude,
      "longitude": capture.longitude,
      "showSalida": capture.showSalida,
      'entrega':capture.entrega,
      'observaciones':capture.observaciones,
      "api_token": this.token.api_token,
    }
    return this.http.post(url, data);

    //  return this.capture;
    //this.listCapture.push(capture);
  }

  dataRegisPers($dataPers) {
    let url = this.url + '/dataPersIngreso?';

    // const data = {
    //   "id_planta": capture.id_planta,
    //   "cedula": capture.cedula,
    //   "orden_ceco": capture.orden_ceco,
    //   "linea": capture.linea,
    //   "api_token": this.token.api_token,
    // }
    return this.http.post(url, $dataPers);

    //  return this.capture;
    //this.listCapture.push(capture);
  }

  dataFiltroHora($dataApi) {
    let url = this.url + '/dataFiltroHoras?';
    return this.http.post(url, $dataApi);
  }





}


